import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { Flex } from "~/components/blocks";

const DIAMETER = "16px";
const LINE_WEIGHT = "4px";

type Props = {
  active?: boolean;
  label: string;
};

const Label = styled("div")(({ theme }) =>
  css({
    color: theme.colors.text.default,
    fontWeight: theme.fontWeights.bold,
    fontSize: theme.fontSizes.xs,
  }),
);

const Dot = styled("div")(({ theme }) =>
  css({
    zIndex: 1,
    background: theme.colors.background.disabled,
    height: DIAMETER,
    width: DIAMETER,
    borderRadius: "50%",
  }),
);

const Root = styled(Flex)<{ active?: boolean }>(({ theme, active }) =>
  css({
    alignItems: "center",
    flex: 1,
    flexDirection: "column",
    position: "relative",
    "&::after": {
      background: active
        ? theme.colors.background.primary
        : theme.colors.background.disabled,
      content: '""',
      height: LINE_WEIGHT,
      left: "-50%",
      position: "absolute",
      top: `calc(${DIAMETER} / 2 - ${LINE_WEIGHT} / 2)`, // 「Dotの1/2の高さ - 線の1/2の高さ」で円の半分から線が出る
      width: "100%",
      zIndex: 0,
    },
    "&::before": {
      content: '""',
      background: active
        ? theme.colors.background.primary
        : theme.colors.background.disabled,
      height: LINE_WEIGHT,
      right: "-50%",
      position: "absolute",
      top: `calc(${DIAMETER} / 2 - ${LINE_WEIGHT} / 2)`, // 「Dotの1/2の高さ - 線の1/2の高さ」で円の半分から線が出る
      width: "100%",
      zIndex: 0,
    },
    "&:first-of-type:after": {
      display: "none",
    },
    "&:last-of-type:before": {
      display: "none",
    },
    [`> ${Label}`]: {
      color: active
        ? theme.colors.background.primary
        : theme.colors.background.disabled,
    },
    [`> ${Dot}`]: {
      background: active
        ? theme.colors.background.primary
        : theme.colors.background.disabled,
    },
  }),
);

export const Step = React.memo((props: Props) => {
  return (
    <Root active={props.active}>
      <Dot />
      <Label>{props.label}</Label>
    </Root>
  );
});

Step.displayName = "Step";
